<procure-card class="page-has-error">
  <p class="page-has-error__text">There was an error while loading the page.</p>
  <div class="page-has-error__actions">
    <button
      class="page-has-error__button"
      procure-button
      (click)="retry.emit()"
    >
      Retry
    </button>
    @if (redirectUrl && redirectLabel) {
      <button
        class="page-has-error__button"
        procure-button
        [routerLink]="redirectUrl"
      >
        {{ redirectLabel }}
      </button>
    }
  </div>
</procure-card>
